<template>
  <div class="page-content">
    <el-empty description="暂无数据" :image="require('@/assets/images/empty.png')" />
  </div>
  <div class="create-btn">
    <el-button type="primary" round size="large" icon="Plus" style="background: linear-gradient(to right, #9b2a5b, #ff7e5f); border: none;" @click="createGroup">创建聊天室</el-button>
  </div>
</template>
<script lang="ts" setup>
import { onMounted } from "vue";

const createGroup = () => {
  console.log('创建群')
}
onMounted(() => {
})
</script>
<style lang="scss" scoped>
.page-content {
  padding-top: 44px;
  width: 100%;
}

.create-btn {
  position: fixed;
  bottom: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
